<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf="(newModel == true)" class="modal-title" id="exampleModalLabel" i18n="@@">Create</h5>
    <h5 *ngIf="(newModel == false)" class="modal-title" id="exampleModalLabel" i18n="@@">
        Edit - {{model.name}} | v{{model.version}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div class="card-header mt-3">

    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
        role="tablist">
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body " style="text-align: center" data-bs-toggle="tab" role="tab">
                <i class="fas fa-home"></i>
                <div i18n="@@"> Machine Details</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row ">
                    <div class="col-12 ">
                        <div class="mb-3">
                            <label i18n="@@">Machine Name</label>
                            <input required #fsmName="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [disabled]="disableEditing || !((newModel === false && securityPermissionFSMUpdate) || (newModel === true && securityPermissionFSMCreate))"
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': ((fsmName.invalid)&& ((fsmName.dirty || fsmName.touched) || submitted == true))}"
                                class="form-control" type="text" placeholder="Enter Finite State Machine Name"
                                i18n-placeholder="@@" [(ngModel)]="model.name" (keypress)="modalEdited = true" />
                            <div *ngIf="((fsmName.invalid) && ((fsmName.dirty || fsmName.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="fsmName.errors?.['required']">
                                    <div i18n="@@">Finite State Machine Name Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@">Interval</label>
                            <select #fsmInterval="ngModel" required
                                [disabled]="disableEditing || !((newModel === false && securityPermissionFSMUpdate) || (newModel === true && securityPermissionFSMCreate))"
                                class="form-select" (change)="modalEdited = true" [(ngModel)]="model.interval"
                                [ngClass]="{ 'is-invalid': ((fsmInterval.invalid) && ((fsmInterval.dirty || fsmInterval.touched) || submitted == true))}">
                                <option *ngFor="let key of fsmIntervalAvailableOptions" value="{{key.value}}">
                                    {{key.text}}
                                </option>
                            </select>
                            <div *ngIf="((fsmInterval.invalid) && ((fsmInterval.dirty || fsmInterval.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="fsmInterval.errors?.['required']">
                                    <div i18n="@@">Interval Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@">Enabled Status</label>
                            <div class="form-check form-switch">
                                <input
                                    [disabled]="disableEditing || !((newModel === false && securityPermissionFSMUpdate) || (newModel === true && securityPermissionFSMCreate))"
                                    class="form-check-input" type="checkbox" [checked]="model.isEnabled"
                                    (change)="model.isEnabled = !model.isEnabled" />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
</div>

<div class="card-body p-4  ">
    <div [ngbNavOutlet]="customNav" style=" overflow: scroll; min-height: 28rem; max-height:fit-content; "></div>
    <div class="hstack justify-content-end" style="margin-top: 0.5rem;">
        <button [disabled]="disableEditing" type="button" class="btn btn-success" id="add-btn" (click)="onSave()">
            <span *ngIf="(newModel == true) && securityPermissionFSMCreate" i18n="@@ContactPopUp_btn_CreateContact">
                Create
            </span>
            <span *ngIf="(newModel == false) && securityPermissionFSMUpdate" i18n="@@ContactPopUp_btn_UpdateContact">
                Update
            </span>
        </button>
    </div>
</div>